import { createAuthClient } from "better-auth/react"
import { twoFactorClient } from "better-auth/client/plugins"
import { authBaseUrl } from "./api"

export const authClient = createAuthClient({
  baseURL: authBaseUrl,
  plugins: [twoFactorClient({ onTwoFactorRedirect: async () => undefined })],
  fetchOptions: { credentials: "include" },
  sessionOptions: { refetchOnWindowFocus: false },
})
